import { createApp } from 'vue';

import App from './App.vue';
import { reveal } from './directives/reveal';
import './assets/css/app.scss';

createApp(App).directive('reveal', reveal).mount('#app');
